module.exports = __webpack_public_path__ + "img/plans-hero.887f3ed8.jpg";